import React, { FC } from 'react'

export type KeySwitchProps = {
  checked: boolean
  small?: boolean
  disabled?: boolean
  onClick?: () => void
}
/**
 * @deprecated key-* components are no longer supported.
 */
export const KeySwitch: FC<KeySwitchProps> = (props) => {
  const { checked, small = false, disabled = false, onClick } = props

  const size = small ? 'w-[30px] h-[16px]' : 'w-[48px] h-[24px]'
  const handleSize = small ? 'w-[10px] h-[10px]' : 'w-[18px] h-[18px]'

  const position = checked ? 'right-[3px]' : 'left-[3px]'
  const bg = disabled ? 'opacity-50' : checked ? 'bg-sky-400' : 'bg-white'
  const handleBg = disabled ? 'bg-gray-500' : checked ? 'bg-white' : 'bg-gray-500'
  const border = disabled ? 'border-gray-400' : checked ? 'border-sky-300' : 'border-gray-400'

  const cursor = disabled ? 'cursor-not-allowed' : 'cursor-pointer'

  return (
    <div
      className={`relative flex items-center border rounded-full duration-200 ease-linear ${border} ${bg} ${size} ${cursor}`}
      onClick={() => {
        if (disabled) return
        else onClick()
      }}
    >
      <div
        className={`absolute rounded-full duration-200 ease-linear ${handleBg} ${position} ${handleSize}`}
      />
    </div>
  )
}
